import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {productCardImagesModalName} from "./config/product-card-images-config";
import {BaseModalComponent} from "../../../../../../core/components/modals/base-modal/base-modal.component";
import {
  FileUploadCardComponent
} from "../../../../../../shared/components/ui/file-upload-card/file-upload-card.component";
import {FileCardComponent} from "../../../../../../shared/components/ui/file-card/file-card.component";
import {AttachProductCardImage, ProductCardImage} from "../../../types/product-card-image.types";
import {AttachFileParams} from "../../../../../../core/types/file.types";
import {ProductCardImagesDialogData} from "./types/product-card-images-modal.types";
import {ProductCardImagesStateService} from "../../../services-state/product-card-images-state.service";
import {ProductCardImagesService} from "../../../services/product-card-images.service";

@Component({
  selector: 'app-product-card-images-modal',
  imports: [
    BaseModalComponent,
    FileUploadCardComponent,
    FileCardComponent
  ],
  templateUrl: './product-card-images-modal.component.html',
  styleUrl: './product-card-images-modal.component.scss'
})
export class ProductCardImagesModalComponent  extends BaseModalComponent {
  public productCardImagesDialogData = inject<ProductCardImagesDialogData>(MAT_DIALOG_DATA);
  public productCardImagesStateService: ProductCardImagesStateService = inject(ProductCardImagesStateService);
  private productCardImagesService: ProductCardImagesService = inject(ProductCardImagesService);

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(productCardImagesModalName);
    this.editModeService.setEditMode(true);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(productCardImagesModalName);
  }

  public async handleDelete(isImage: boolean, productCardImage: ProductCardImage): Promise<void> {
    this.productCardImagesService.deleteProductCardImage(productCardImage.id)
      .then(() => this.productCardImagesStateService.deleteFilesData(productCardImage.id));
  }

  public async attachFile(attachFileParams: AttachFileParams): Promise<void> {
    const attachProductCardImage: AttachProductCardImage = {
      productCardId: attachFileParams.parentId,
      fileId: attachFileParams.fileId
    };

    await this.productCardImagesService.attachProductCardImage(attachProductCardImage)
      .then((productCardImage) => this.productCardImagesStateService.updateFilesData(productCardImage));
  }
}
